<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      Készletátadás megtekintése
      <el-tag
        v-if="representativeTransfer.status"
        size="small"
        :type="getStatus().tag"
        style="margin-left: 5px;"
      >
        {{ getStatus().label }}
      </el-tag>
      <span v-if="representativeTransfer.representative_transfer_request_id" style="margin-left: 15px; font-size: 14px; color: #606266;">
        A(z) <router-link
          :to="'/representative-processes/representative-transfer-requests/view/' + representativeTransfer.representative_transfer_request_id"
          style="color: #409EFF;"
        >{{ representativeTransfer.representative_transfer_request_id }}. számú készletátadási kérelem</router-link> alapján
      </span>
    </div>
    <div v-loading="loading">
      <el-form
        ref="transferForm"
        label-position="top"
        :model="representativeTransfer"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              prop="supplier"
              label="Átadó"
            >
              <el-input
                v-model="representativeTransfer.supplier.full_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="sourceStorage"
              label="Forrás raktár"
            >
              <el-input
                v-model="representativeTransfer.source_storage.name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="customer"
              label="Átvevő"
            >
              <el-input
                v-model="representativeTransfer.customer.full_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="target_storage"
              label="Cél raktár"
            >
              <el-input
                v-model="representativeTransfer.target_storage.name"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              prop="receipt_number"
              label="Bizonylatszám"
            >
              <el-input
                v-model="representativeTransfer.receipt_number"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Rögzítette"
              prop="creator_user"
            >
              <el-input
                v-model="representativeTransfer.creator_user.full_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Létrehozva"
              prop="created_at"
            >
              <el-input
                :value="representativeTransfer.created_at | dateTime"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Nettó összeg"
              prop="net_price"
            >
              <el-input
                :value="formatPrice(representativeTransfer.net_price)"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <product-items
          ref="productItems"
          :load-base-count-from-stock="false"
          :is-product-select-from-stock="false"
          :default-items="representativeTransfer.order_items"
          :enabled-elements="[]"
          :enabled-columns="['product', 'supplierSelector', 'productPackType', 'expirationDateSelector', 'count', 'purchaseUnitPrice', 'vat']"
        />
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-if="representativeTransfer.receipt_file"
        @click="openReceipt"
      >
        Bizonylat nyomtatása
      </el-button>
      <el-button
        @click="handleClose"
      >
        Bezárás
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import ProductItems from '../../utils/ProductItems/index';

  export default {
    components: {
      ProductItems,
    },
    props: ['representativeTransferId'],
    data() {
      return {
        loading: false,
        representativeTransfer: {
          status: '',
          net_price: 0,
          gross_price: 0,
          order_items: [],
          customer: {},
          supplier: {},
          creator_user: {},
          source_storage: {},
          target_storage: {},
          receipt_number: '',
          receipt_file: null,
          created_at: '',
          representative_transfer_request_id: null,
        },
      };
    },
    async mounted() {
      this.loading = true;
      if (this.representativeTransferId) {
        const transfer = await this.$store.dispatch('representativeTransfer/fetch', this.representativeTransferId);
        this.representativeTransfer = transfer;
      }
      this.loading = false;
    },
    methods: {
      handleClose() {
        this.$router.replace('/representative-processes/representative-transfers');
      },
      openReceipt() {
        if (this.representativeTransfer.receipt_file) {
          window.open(this.representativeTransfer.receipt_file);
        }
      },
      formatPrice(price) {
        if (!price) return '0 Ft';
        return new Intl.NumberFormat('hu-HU').format(price) + ' Ft';
      },
      getStatus() {
        switch (this.representativeTransfer.status) {
          case 'done':
            return {
              label: 'Átvéve',
              tag: 'success',
            };
          case 'dropped':
            return {
              label: 'Átvételre vár',
              tag: 'info',
            };
          case 'recorded':
            return {
              label: 'Rögzítve',
              tag: 'info',
            };
          case 'cancelled':
            return {
              label: 'Visszavonva',
              tag: 'danger',
            };
          default:
            return {
              label: '',
              tag: '',
            };
        }
      },
    },
  };
</script>
